import { z } from 'zod'

export const AGENTMCP_ARTIFACTS_CONTRACT_VERSION = '1.0.0' as const

export const agentmcpArtifactUploadResponseSchema = z.object({
  key: z.string(),
  url: z.string(),
}).passthrough()

export const agentmcpArtifactDeleteResponseSchema = z.object({
  key: z.string(),
  deleted: z.boolean(),
}).passthrough()

export type AgentmcpArtifactUploadResponse = z.infer<typeof agentmcpArtifactUploadResponseSchema>
export type AgentmcpArtifactDeleteResponse = z.infer<typeof agentmcpArtifactDeleteResponseSchema>
